'use strict';

var ImageLoadObserver = require('./ImageLoadObserver.js');
var DocumentObserver = require('./DocumentObserver.js');

function LiveImageLoadObserver(styleClass) {
	// Bind methods to 'this'
	this.observe = this.observe.bind(this);
	
	// Observe instances of elements styleClass as they are created, or removed
	DocumentObserver.getInstance().onStyleClass(
		styleClass,
		this.observe
	);
}

/**
 * @public
 * @param elem {Element|Element[]}
 */
LiveImageLoadObserver.prototype.observe = function(elems) {
	if (Array.isArray(elems)) {
		for (var i = 0, len = elems.length, elem; i < len; i++) {
			new ImageLoadObserver(elems[i], onImageLoaded);
		}
	} else {
		new ImageLoadObserver(elems, onImageLoaded);
	}
}


/**
 * @private
 */
function onImageLoaded(imageLoadObserver) {
	var elem = imageLoadObserver.getElement();
	var bgTarget = elem.dataset['onloadBgtarget'];
	
	var targetForBg = null; // Using null because that is what querySelector() returns if not found.
	if (bgTarget !== undefined) {
		if (bgTarget === 'self') {
			targetForBg = elem;
		} else {
			targetForBg = elem.querySelector(bgTarget);
		}
	} else if (
		elem.classList.contains('image--coverFit')
		|| elem.classList.contains('image--containFit')
	) {
		targetForBg = elem;
	}
	
	if (targetForBg !== null) {
		var src = imageLoadObserver.getSrc();
		targetForBg.style.backgroundImage = 'url("' + src + '")';
	}
}

module.exports = LiveImageLoadObserver;

